import { useEffect, useState } from "react";
import "./Address.scss";
import store, { RootState } from "../../../store/store";
import { getSessionVariable } from "../../../shared/utils/utils";
import { LOCATION, cookieNames } from "../../../shared/constants/constants";
import { getPartyContactDetails } from "../../../store/api/order";
import { createPartyContactMech, updatePartyContactMech } from "../../../store/api/party";
import { Box, Button, Card, Container, FormControl, IconButton, Input, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { AppRegistration, Update } from "@mui/icons-material";
import { useSelector } from "react-redux";
interface AddressModel {
  address?: string;
  pincode?: string;
  city?: string;
  id?: string;
  type?: string;
}

const Address = () => {
  const [orgPartyId, setOrgPartyId] = useState("");
  let [editMode, setEditMode] = useState<String>("");
  let [actualOrganizationAddress, setActualOrganizationAddress] = useState<AddressModel[]>([]);
  let [actualShippingAddress, setActualShippingAddress] = useState<AddressModel[]>([]);
  let [actualBillingAddress, setActualBillingAddress] = useState<AddressModel[]>([]);
  const [update, setUpdate] = useState<boolean>(false);
  const storeParentPartyOrg = useSelector(
    (state: RootState) => state.party.parentOrg
  );

  const [editAddress, setEditAddress] = useState<AddressModel>({
    address: "",
    pincode: "",
    city: "",
    id: "",
    type: "",
  })

  const saveOrEdit = async (type:String, address:AddressModel = editAddress) => {
    if (!editMode || editMode==="") {
      setEditMode(type);
      setEditAddress(address)
    } else {
      try {
        let addressesToAddOrUpdate: any = [];

        if (editAddress.type === LOCATION.PRIMARY) {
          addressesToAddOrUpdate.push(editAddress);
        }

        if (editAddress.type === LOCATION.BILLING) {
          addressesToAddOrUpdate.push(editAddress);
        }

        if (editAddress.type === LOCATION.SHIPPING) {
          addressesToAddOrUpdate.push(editAddress);
        }

        if (addressesToAddOrUpdate.length) {
          let res: any = await Promise.all(addressesToAddOrUpdate.map((address: any) => addOrUpdateAddress(address, editMode)));

          res.forEach((address: any) => {
            setUpdate(!update)
          });
        } else {
          // console.log("No address changes to add or update")
        }

        setEditMode("");
      } catch (error) {
        console.log(error);
      }
    }
  };

  const addOrUpdateAddress = async (address: any, type:String ) => {
    // Updating if ID is present else creating
    try {
      if (address.id) {
        const updateContactMechRequestBody: any = {
          contactmechType: 'POSTAL_ADDRESS',
          purposeType: address.type,
          partyContactMechId: address.id,
          detail: {}
        };

        const createContactMechRequestBody: any = {
          contactmechType: 'POSTAL_ADDRESS',
          purposeType: address.type,
          partyId: orgPartyId,
          detail: {}
        };
    
        updateContactMechRequestBody.detail.address1 = address.address;
        updateContactMechRequestBody.detail.city = address.city;
        updateContactMechRequestBody.detail.pincode = address.pincode;
  
        {editMode==="Add"?
        await store
        .dispatch(createPartyContactMech(updateContactMechRequestBody))
        .unwrap()
        :
        await store
        .dispatch(updatePartyContactMech(updateContactMechRequestBody))
        .unwrap();
        }
        return address
      } else {
        const prismUser:any = getSessionVariable(cookieNames.prismUser);
        const orgPartyId = JSON.parse(prismUser).orgPartyIds[0];

        const createContactMechRequestBody: any = {
          contactmechType: 'POSTAL_ADDRESS',
          purposeType: address.type,
          partyId: orgPartyId,
          detail: {}
        };
    
        createContactMechRequestBody.detail.address1 = address.address;
        createContactMechRequestBody.detail.city = address.city;
        createContactMechRequestBody.detail.pincode = address.pincode;
  
        await store
        .dispatch(createPartyContactMech(createContactMechRequestBody))
        .unwrap();

        return address;
      }
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        const prismUser = getSessionVariable(cookieNames.prismUser);
        if (prismUser && prismUser !== "") {
          let orgPartyId = JSON.parse(prismUser).orgPartyIds[0];
          setOrgPartyId(orgPartyId)
          const res = await store
            .dispatch(getPartyContactDetails(orgPartyId))
            .unwrap();
          // console.log(res)
          let addresses = res.data.filter(
            (contact: any) => contact.contactmechType === "POSTAL_ADDRESS"
          );
          let primaryArray: AddressModel[] = []
          let shipArray: AddressModel[] = []
          let billArray: AddressModel[] = []
          addresses.forEach((address: any) => {
            if (address.purposeType.includes(LOCATION.PRIMARY)) {
              const localOrganizationAddress = {
                address: address.detail.address1,
                pincode: address.detail.pincode,
                city: address.detail.city,
                id: address["_id"],
                type: LOCATION.PRIMARY,
              };
              primaryArray.push(localOrganizationAddress)
            } else if (address.purposeType.includes(LOCATION.SHIPPING)) {
              const localShippingAddress = {
                address: address.detail.address1,
                pincode: address.detail.pincode,
                city: address.detail.city,
                id: address["_id"],
                type: LOCATION.SHIPPING,
              };
              shipArray.push(localShippingAddress)
            } else if (address.purposeType.includes(LOCATION.BILLING)) {
              const localBillingAddress = {
                address: address.detail.address1,
                pincode: address.detail.pincode,
                city: address.detail.city,
                id: address["_id"],
                type: LOCATION.BILLING
              }
              billArray.push(localBillingAddress);
            }
          });
          setActualBillingAddress(billArray?.map((element)=>element));
          setActualOrganizationAddress(primaryArray?.map((element)=>element));
          setActualShippingAddress(shipArray?.map((element)=>element))
          
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [update]);

  return (
    <Box className="address">
      {editMode!==""?    
      <Container sx={{paddingLeft: '12px !important', paddingRight: '12px !important'}}> 
        <Stack gap={2} className='editHeader'>
          <Typography variant="h1">{editMode==="Add"?"Add":"Edit"} {editMode==="Add"?"":editMode==="org"?"Primary":editMode==="bill"?"Billing":"Shipping"} Address</Typography>
          <Stack direction={{ xs: "column", md: "row" }} gap={2}>
            <Stack width={{ xs: "100%", md: "40%" }} gap={1} className="editInput">
            <Typography variant="body1">Address Type</Typography>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={editAddress?.type}
                  onChange={(e)=>setEditAddress({...editAddress, type:e.target.value})}
                  disabled = {editMode!=="Add"}
                >
                   {storeParentPartyOrg==="" && <MenuItem value={ LOCATION.PRIMARY}>Primary</MenuItem>}
                  <MenuItem value={ LOCATION.SHIPPING}>Shipping</MenuItem>
                  {storeParentPartyOrg==="" && <MenuItem value={ LOCATION.BILLING}>Billing</MenuItem>}
                </Select>
              </FormControl>
            </Stack>
            <Stack width={{ xs: "100%", md: "40%" }} gap={1} className="editInput">
              <Typography variant="body1">Address Line 1</Typography>
              <TextField fullWidth className='addressTextArea' placeholder='Address here' value={editAddress?.address} onChange={(e) => setEditAddress({ ...editAddress, address: e.target.value })}/>
            </Stack>
          </Stack>
          <Stack direction={{ xs: "column", md: "row" }} gap={2}>
            <Stack width={{ xs: "100%", md: "40%" }} gap={1} className="editInput">
              <Typography variant="body1">Pincode</Typography>
              <TextField fullWidth className='addressInput' placeholder='Pincode here' type="number" value={editAddress?.pincode} onChange={(e) => setEditAddress({ ...editAddress, pincode: e.target.value })} />
            </Stack>
            <Stack width={{ xs: "100%", md: "40%" }} gap={1} className="editInput">
              <Typography variant="body1">City</Typography>
              <TextField fullWidth className='addressInput' type="text" placeholder='City here' value={editAddress?.city} onChange={(e) => setEditAddress({ ...editAddress, city: e.target.value })} />
            </Stack>
          </Stack>
          <Box sx={{width:{md:"30%", sm:"40%", xs:"50%"}}} className="submitBtn">
            <Button variant="contained" onClick={()=>saveOrEdit(editMode,editAddress)}>Submit</Button>
          </Box>
        </Stack>
    </Container>:
    <Container  sx={{paddingLeft: '12px !important', paddingRight: '12px !important'}}>
      <Stack>
        { storeParentPartyOrg==="" &&  <Card sx={{"margin":2, borderRadius:0}}>
          <Stack>
            <Box className="cardHeader" p={2}>
              <Typography>Primary Addresses</Typography>
            </Box>
            {actualOrganizationAddress?.map((element)=>{
              return (
              <Stack direction={{ xs: "column", md: "row" }} gap={2} p={2}>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">Address</Typography>
                  <Typography variant="body2">{element.address}</Typography>
                </Stack>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">Postcode</Typography>
                  <Typography variant="body2">{element.pincode}</Typography>
                </Stack>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">City</Typography>
                  <Typography variant="body2">{element.city}</Typography>
                </Stack>
                <Stack p={1} className="editBtn">
               { storeParentPartyOrg==="" &&  <Button size="large" startIcon={<AppRegistration />} onClick={()=>saveOrEdit("org",element)}>
                  <Typography>EDIT</Typography>
                </Button>}
                </Stack>
              </Stack>
                )
            })}
          </Stack>
        </Card>}
        { storeParentPartyOrg==="" &&  <Card sx={{"margin":2, borderRadius:0}}>
          <Stack>
            <Box className="cardHeader" p={2}>
              <Typography>Billing Addresses</Typography>
            </Box>
            {actualBillingAddress?.map((element)=>{
              return (
              <Stack direction={{ xs: "column", md: "row" }} gap={2} p={2}>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">Address</Typography>
                  <Typography variant="body2">{element.address}</Typography>
                </Stack>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">Postcode</Typography>
                  <Typography variant="body2">{element.pincode}</Typography>
                </Stack>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">City</Typography>
                  <Typography variant="body2">{element.city}</Typography>
                </Stack>
                <Stack p={1} className="editBtn">
                {storeParentPartyOrg==="" && <Button size="large" startIcon={<AppRegistration />} onClick={()=>saveOrEdit("bill",element)}>
                  <Typography>EDIT</Typography>
                </Button>}
                </Stack>
              </Stack>
                )
            })}
          </Stack>
        </Card>}
        <Card sx={{"margin":2, borderRadius:0}}>
          <Stack>
            <Box className="cardHeader" p={2}>
              <Typography>Shipping Addresses</Typography>
            </Box>
            {actualShippingAddress?.map((element)=>{
              return (
              <Stack direction={{ xs: "column", md: "row" }} gap={2} p={2}>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">Address</Typography>
                  <Typography variant="body2">{element.address}</Typography>
                </Stack>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">Postcode</Typography>
                  <Typography variant="body2">{element.pincode}</Typography>
                </Stack>
                <Stack gap={1} width={{ xs: "100%", md: "30%" }} className="detailSection" p={1}>
                  <Typography variant="body1">City</Typography>
                  <Typography variant="body2">{element.city}</Typography>
                </Stack>
                <Stack p={1} className="editBtn">
                <Button size="large" startIcon={<AppRegistration />} onClick={()=>saveOrEdit("ship",element)}>
                  <Typography>EDIT</Typography>
                </Button>
                </Stack>
              </Stack>
                )
            })}
          </Stack>
        </Card>
        <Box p={2} sx={{width:{md:"30%", sm:"40%", xs:"50%"}}} className="submitBtn">
          <Button variant="contained" onClick={()=>saveOrEdit("Add",editAddress)}>Add Address</Button>
        </Box>
      </Stack>
    </Container>
    }
    </Box>
  );
};

export default Address;
